export const modalBaseStyle = {
  background: "rgba(0, 0, 0, 0.20)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
